import React from "react";
import { connect, ConnectedProps } from 'react-redux';
import { Route, RouteProps } from "react-router-dom";
import * as Core from '../../core';
import { ApplicationState } from '../..';
import SelezionaAnagrafica from "./SelezionaAnagrafica";

const connector = connect(
    (state: ApplicationState) => ({
        anagrafiche: state.core.anagrafiche.lista,
        anagrafica: state.core.anagrafiche.anagrafica
    }),
    Core.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type AnagraficaRouteProps = 
    RouteProps &
    PropsFromRedux

class AnagraficaRoute extends Route<AnagraficaRouteProps> {

    componentDidMount() {
        const { anagrafiche } = this.props;
        if (anagrafiche.length === 1) {
            this.props.loadAnagrafiche();
        }
    }

    componentDidUpdate(prevProps: AnagraficaRouteProps) {
        const { anagrafiche } = this.props;
        if (prevProps.anagrafiche.length === 0 && anagrafiche.length === 1) {
            this.props.anagraficaSelezionata(anagrafiche[0]);
        }
    }

    render() {
        const { anagrafica } = this.props;
        return anagrafica === undefined ?
            <SelezionaAnagrafica /> :
            <Route {...this.props} />
    }
}

export default connector(AnagraficaRoute);
